import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoBackComponent } from '../go-back/go-back.component';
import { Observable } from 'rxjs';
import { TransactionInstructionsRedirectUrlViewModel } from 'ui/features/transactions/services/transaction-instructions-redirect-url-view-model.service';
import { UrlHandlerService } from 'ui/shared/services/url-handler.service';

@Component({
    selector: 'app-go-back-instructions-from-validations',
    standalone: true,
    imports: [CommonModule, GoBackComponent],
    templateUrl: './go-back-instructions-from-validations.component.html',
    styleUrls: ['./go-back-instructions-from-validations.component.scss']
})
export class GoBackInstructionsFromValidationsComponent {
    public redirectUrl$: Observable<string | null>;

    public constructor(
        private redirectUrlViewModel: TransactionInstructionsRedirectUrlViewModel,
        private urlHandlerService: UrlHandlerService
    ) {
        this.redirectUrl$ = this.redirectUrlViewModel.redirectUrl$.asObservable();
        this.redirectUrlViewModel.fetchRedirectUrl();
    }

    public returnToInstructions(): void {
        const url: string | null = this.redirectUrlViewModel.getRedirectUrl();
        if (!url) {
            return;
        }
        this.urlHandlerService.handleUrl(url);
    }
}
